var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      attrs: {
        title: _vm.$t("BusinessPurchaseApplyDetail.dialogText2"),
        visible: _vm.logVisible,
        width: "500px",
      },
      on: {
        "update:visible": function ($event) {
          _vm.logVisible = $event
        },
      },
    },
    [
      _c(
        "el-table",
        {
          attrs: {
            data: _vm.logList,
            border: "",
            script: "",
            "max-height": "600px",
          },
        },
        [
          _c("el-table-column", {
            attrs: {
              prop: "lastUpdateDate",
              label: _vm.$t("BjDialogListConfig.Operationtime"),
              align: "center",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    false
                      ? void 0
                      : _c("span", [
                          _vm._v(
                            _vm._s(
                              _vm._f("timeFilters")(
                                scope.row.lastUpdateDate,
                                scope.row.lastUpdateDate
                              )
                            )
                          ),
                        ]),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: {
              prop: "createdName",
              label: _vm.$t("BjDialogListConfig.Operator"),
              align: "center",
            },
          }),
          _c(
            "el-table-column",
            {
              attrs: {
                prop: "remarks",
                label: _vm.$t("BjDialogListConfig.Remarks"),
                align: "center",
              },
            },
            [[false ? void 0 : _c("span", [_vm._v("Delete file")])]],
            2
          ),
        ],
        1
      ),
      _c(
        "span",
        {
          staticClass: "dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer",
        },
        [
          _c("el-button", { on: { click: _vm.handleClose } }, [
            _vm._v(_vm._s(_vm.$t("cancelText"))),
          ]),
          _c(
            "el-button",
            { attrs: { type: "primary" }, on: { click: _vm.handleConfirm } },
            [_vm._v(_vm._s(_vm.$t("okText")))]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }